import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useCallback } from 'react';
import CallToConfirmActionDialog from './CallToConfirmActionDialog';
import { Company } from '../../Configs/general';

const CallToAssociationConfirmActionDialog = ({
  open,
  title,
  onAccept = () => {},
  onDeny = () => {},
  acceptText = 'Aceptar',
  denyText = 'Cancelar'
}) => {
  const classes = useStyles();

  const renderConfirmAssociationActionContent = useCallback(() => {
    return (
      <>
        <Typography paragraph className={classes.dialogText}>
          Al asociar tu {Company.contractConjugation.regular.singular.main}{' '}
          podrás disfrutar de los siguientes beneficios <br />
        </Typography>
        <ul className={classes.dialogItemText}>
          <li>Realizar tus pagos en línea.</li>
          <li>Consultar tus facturas y acceder a tu historial de pagos.</li>
          <li>Realizar solicitudes y adelantar trámites. </li>
          <li>Consultar y gestionar tu cupo Brilla. </li>
        </ul>
      </>
    );
  }, [classes.dialogText, classes.dialogItemText]);

  return (
    <CallToConfirmActionDialog
      open={open}
      onAccept={onAccept}
      onDeny={onDeny}
      acceptText={acceptText}
      denyText={denyText}
      content={renderConfirmAssociationActionContent}
      title={title}
    />
  );
};

const useStyles = makeStyles(() => ({
  dialogText: {
    fontSize: 16
  },
  dialogItemText: {
    fontSize: 14,
    paddingLeft: '24px'
  }
}));

export default CallToAssociationConfirmActionDialog;
